import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { createWellnessEntity } from '../../store/actions/entityActions'
import firebase from "firebase/compat/app";
import 'firebase/compat/firestore'
import { useNavigate, useParams } from 'react-router-dom';
import { styles } from '../layout/styles'
import { Button, Card, CardBody, Modal, Table } from 'react-bootstrap'
import { pdf, Document, Text, Page } from '@react-pdf/renderer';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import CompleteWellnessReport from '../layout/WellnessReport/CompleteWellnessReport';
import FirstPage from '../layout/WellnessReport/FirstPage';
import PhysicalGrowthPage from '../layout/WellnessReport/PhysicalGrowthPage'
import DevMilestonePage from '../layout/WellnessReport/DevMilestonePage'
import NutritionalPage from '../layout/WellnessReport/NutritionalPage'
import NutritionalSupplementalPage from '../layout/WellnessReport/NutritionalSupplementPage';
import SocialPage from '../layout/WellnessReport/SocialPage'
import EmotionalPage from '../layout/WellnessReport/EmotionalPage'
import EmotionalSupplementPage from '../layout/WellnessReport/EmotionalSupplementPage'
import OralRiskPage from '../layout/WellnessReport/OralRiskPage'
import VaccinationPage from '../layout/WellnessReport/VaccinationPage'
import VaccinationSupplementPage from '../layout/WellnessReport/VaccinationSupplementPage'
import SummaryPage from '../layout/WellnessReport/SummaryPage'

function WellnessWizard (props, ownProps) {
    const { id } = useParams();
    const entity = props.entities.find(item => item.id === id);//useSelector((state) => state);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [ showAlertModal, setshowAlertModal ] = useState(false);
    function handleAlertModalClose() { setshowAlertModal(false); navigate('/');}
    function handleAlertModalShow() { setshowAlertModal(true);}

    // const [ pWellnessreportlocation, setpWellnessreportlocation ] = useState('');
    const currentTimestamp = Date.now();
    const reportURL = props.auth.uid + "/" + id + "/" + currentTimestamp + ".pdf"
    //console.log(reportURL);
    let downloadURL = '';

    const wellnessprogramdateRef = useRef()
    const parenttypeRef = useRef()
    const parentnameRef = useRef(entity.createdbyuserfullname)
    const childageRef = useRef()
    const childweightRef = useRef(entity.weight)
    const childheightRef = useRef(entity.height)
    const agerangeRef = useRef()
    const primarydietRef = useRef()
    const cerealintakethreemealsRef = useRef()
    const snacksmidmorningeveningRef = useRef()
    const mealingredientRef = useRef()
    const threecupsmilkRef = useRef()
    const greenvegetablesRef = useRef()
    const othervegetablesintakeRef = useRef()
    const fruitintakeRef = useRef()
    const skipmealsRef = useRef()
    const junkfoodintakeRef = useRef()
    const streetfoodintakeRef = useRef()
    const physicalexerciseRef = useRef()
    const digitalscreentimeRef = useRef()
    const sleeptimesRef = useRef()
    const highsugarfoodintakeRef = useRef()
    const highsugardrinkintakeRef = useRef()
    const refinedfoodsRef = useRef()

    function trailReport() {
        const questionaire = {
            entityid:id,
            wellnessprogramdate: firebase.firestore.Timestamp.fromDate(new Date(wellnessprogramdateRef.current.value)),
            wellnessreportlocation: '',
            parenttype: parenttypeRef.current.value,
            parentname: parentnameRef.current.value,
            childage: childageRef.current.value,
            childweight: childweightRef.current.value,
            childheight: childheightRef.current.value,
            agerange: agerangeRef.current.value,
            primarydiet: primarydietRef.current.value,
            cerealintakethreemeals: cerealintakethreemealsRef.current.value,
            snacksmidmorningevening: snacksmidmorningeveningRef.current.value,
            mealingredient: mealingredientRef.current.value,
            threecupsmilk: threecupsmilkRef.current.value,
            greenvegetables: greenvegetablesRef.current.value,
            othervegetablesintake: othervegetablesintakeRef.current.value,
            fruitintake: fruitintakeRef.current.value,
            skipmeals: skipmealsRef.current.value,
            junkfoodintake: junkfoodintakeRef.current.value,
            streetfoodintake: streetfoodintakeRef.current.value,
            physicalexercise: physicalexerciseRef.current.value,
            digitalscreentime: digitalscreentimeRef.current.value,
            sleeptimes: sleeptimesRef.current.value,
            highsugarfoodintake: highsugarfoodintakeRef.current.value,
            highsugardrinkintake: highsugardrinkintakeRef.current.value,
            refinedfoods: refinedfoodsRef.current.value,
        }
        console.log(entity);
        console.log(questionaire);
        navigate('/wellnessreport', {state: {entity:entity, reportParams:questionaire}});
    }
    

    function saveWellnessReport() {
        let stacklen = 1;
        setLoading(true);
        try {
            const storage = getStorage();
            stacklen = 2;
            const storageRef = ref(storage, reportURL);            
            stacklen = 3;

            const reportParams = {
                entityid:id,
                wellnessprogramdate: firebase.firestore.Timestamp.fromDate(new Date(wellnessprogramdateRef.current.value)),
                wellnessreportlocation: downloadURL,
                parenttype: parenttypeRef.current.value,
                parentname: parentnameRef.current.value,
                childage: childageRef.current.value,
                childweight: childweightRef.current.value,
                childheight: childheightRef.current.value,
                agerange: agerangeRef.current.value,
                primarydiet: primarydietRef.current.value,
                cerealintakethreemeals: cerealintakethreemealsRef.current.value,
                snacksmidmorningevening: snacksmidmorningeveningRef.current.value,
                mealingredient: mealingredientRef.current.value,
                threecupsmilk: threecupsmilkRef.current.value,
                greenvegetables: greenvegetablesRef.current.value,
                othervegetablesintake: othervegetablesintakeRef.current.value,
                fruitintake: fruitintakeRef.current.value,
                skipmeals: skipmealsRef.current.value,
                junkfoodintake: junkfoodintakeRef.current.value,
                streetfoodintake: streetfoodintakeRef.current.value,
                physicalexercise: physicalexerciseRef.current.value,
                digitalscreentime: digitalscreentimeRef.current.value,
                sleeptimes: sleeptimesRef.current.value,
                highsugarfoodintake: highsugarfoodintakeRef.current.value,
                highsugardrinkintake: highsugardrinkintakeRef.current.value,
                refinedfoods: refinedfoodsRef.current.value,
            }

            const wellnessReportSample = (
            <Document>
                <Page>
                <Text>Hello {entity.firstname} {entity.lastname}!</Text>
                </Page>
            </Document>
            );

            const wellnessReport = (
                <Document
                    author="ChildrenDoc LLC"
                    keywords="Children, Wellness"
                    subject="ChildrenDoc wellness report"
                    title="ChildrenDoc Online Wellbeing Scan Report"
                >
                    <FirstPage entity={entity} params={reportParams} key={entity.id}/>       
                    <PhysicalGrowthPage entity={entity} params={reportParams} key={entity.id}/>                
                    <DevMilestonePage entity={entity} params={reportParams} key={entity.id}/>       
                    <NutritionalPage entity={entity} params={reportParams} key={entity.id}/>                
                    <NutritionalSupplementalPage entity={entity} params={reportParams} key={entity.id}/>                
                    <SocialPage entity={entity} params={reportParams} key={entity.id}/>                
                    <EmotionalPage entity={entity} params={reportParams} key={entity.id}/>                
                    <EmotionalSupplementPage entity={entity} params={reportParams} key={entity.id}/>                
                    <OralRiskPage entity={entity} params={reportParams} key={entity.id}/>                
                    <VaccinationPage entity={entity} params={reportParams} key={entity.id}/>                
                    <VaccinationSupplementPage entity={entity} params={reportParams} key={entity.id}/>                
                    <SummaryPage entity={entity} params={reportParams} key={entity.id}/>                           
                </Document>
            );

            stacklen = 4;
        
            const asPdf = pdf([]); // {} is important, throws without an argument
            stacklen = 5;
            asPdf.updateContainer(wellnessReport);
            stacklen = 6;
            asPdf.toBlob().then((pdfBlob) => {
                stacklen = 7;
                // save to firebase Storage
                uploadBytes(storageRef, pdfBlob).then((snapshot) => {
                    stacklen = 8;
                    getDownloadURL(snapshot.ref).then((pdownloadURL) => {
                        stacklen = 9;
                        downloadURL = pdownloadURL;
                        if ((downloadURL === '') || (downloadURL === undefined)) {
                            console.log('Wellness Report Error - Upload file missing. ');
                            setLoading(false);
                            return; 
                        }
                
                        if (wellnessprogramdateRef.current.value === '') {
                            var defaultDate = new Date().toISOString().split("T")[0];
                            wellnessprogramdateRef.current.value = defaultDate;
                        }

                        reportParams.wellnessprogramdate = firebase.firestore.Timestamp.fromDate(new Date(wellnessprogramdateRef.current.value));
                        reportParams.wellnessreportlocation = downloadURL;
                
                        console.log(reportParams);
                        //props.createWellnessEntity(pState)
                        props.createWellnessEntity(reportParams)
                        handleAlertModalShow();            
                    });
                    //console.log('Wellness Created with Report Uploaded ' + downloadURL);
                    setLoading(false);
                    return downloadURL;
                })
            });
        } catch (error) {
            console.log('Wellness Report Error - ' + stacklen + ' - ' + error);
            setLoading(false);
            return downloadURL;
        }
    }    
      
    function handleSubmit(e) {
        e.preventDefault();
        saveWellnessReport();
    }

    return (
        <div style={styles.MainBGDivNoAlign}>
            <Modal style={{background:'transparent'}} aria-labelledby="contained-modal-title-vcenter" centered 
                show={showAlertModal} onHide={handleAlertModalClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
            <Modal.Title>Processing your request!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Your information is successfully send to our doctors. </p>
                <p>Please give us couple of minutes before the report appears in your dashboard.</p>                            
            </Modal.Body>
            <Modal.Footer>
            <Button variant="primary" onClick={handleAlertModalClose}>
                Close
            </Button>
            </Modal.Footer>
            </Modal>        

            <div style={styles.DashboardContainer}>
                <form onSubmit={handleSubmit}>
                    <Card style={{ alignContent:'center', alignItem:'center', justifyContent: "center"}}>
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                <div>
                                    <Table responsive="sm">
                                        <tbody>
                                        <tr>
                                            <td style={{textAlign:'left', width:'50%'}}><h3 style={styles.SubHeader}>Wellness Program</h3></td>
                                            <td style={{textAlign:'center', width:'25%'}}><Button disabled={loading} type='submit' style={styles.CDFullButton}>{loading ? 'Generating Report...' : 'Generate Report'}</Button></td>
                                            <td style={{textAlign:'center', width:'25%'}}><Button disabled={loading} style={styles.CDFullButton} onClick={() => navigate("/")}>Cancel</Button></td>
                                            {/* <td style={{textAlign:'center'}}><Button style={styles.CDButton50} onClick={() => trailReport()}>Trail Report</Button></td> */}
                                        </tr>
                                        </tbody>
                                    </Table>                            
                                </div>
                            </Card.Title>
                        </Card.Header>                    
                        <Card.Body>

                        <div >
                            {/* <Card style={{width:'100%', backgroundColor:'transparent'}}> */}
                            <Card className="text-left">
                                <Card.Header className='text-center'> 
                                    <Card.Title>
                                        Nutritional Questionaire
                                    </Card.Title>
                                </Card.Header>                    
                                <CardBody>
                                    <div>
                                        <Table responsive="sm">
                                            <tbody>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label htmlFor="wellnessprogramdate">Wellness program date</label>
                                                        <input id="wellnessprogramdate" type="date" ref={wellnessprogramdateRef}/>
                                                    </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label>Your relationship with {entity.firstname}</label>
                                                        <select id="parenttype" class="browser-default" defaultValue="" ref={parenttypeRef} >
                                                            <option value="" disabled >Choose your option</option>
                                                            <option value="M">Mom</option>
                                                            <option value="D">Dad</option>
                                                            <option value="G">Guardian</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label htmlFor="parentname">Your full name</label>
                                                        <input id="parentname" type="text" ref={parentnameRef} defaultValue={entity.createdbyuserfullname}/>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label htmlFor="childage">{entity.firstname}'s age in months</label>
                                                        <input id="childage" type="number" ref={childageRef}/>
                                                    </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label htmlFor="childweight">{entity.firstname}'s weight</label>
                                                        <input id="childweight" type="number" ref={childweightRef} defaultValue={entity.weight}/>
                                                    </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label htmlFor="childheight">{entity.firstname}'s height</label>
                                                        <input id="childheight" type="number" ref={childheightRef} defaultValue={entity.height}/>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label>Please confirm {entity.firstname}'s age range</label>
                                                            <select id="agerange" class="browser-default" defaultValue="" ref={agerangeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">2 years</option>
                                                                <option value="2">3 to 5 years</option>
                                                                <option value="3">6 years and above</option>
                                                            </select>
                                                    </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label>What is {entity.firstname}'s diet?</label>
                                                            <select id="primarydiet" class="browser-default" defaultValue="" ref={primarydietRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">Vegeterian</option>
                                                                <option value="2">Vegan</option>
                                                                <option value="3">Eggeterian</option>
                                                                <option value="4">Non vegeterian</option>
                                                            </select>
                                                    </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} have 3 main meals of cereals like wheat, rice, oats, etc.?</label>
                                                            <select id="cerealintakethreemeals" class="browser-default" defaultValue="" ref={cerealintakethreemealsRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="Y">Yes</option>
                                                                <option value="N">No</option>
                                                            </select>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                    <label>Does {entity.firstname} have mid-morning and evening snack daily?</label>
                                                        <select id="snacksmidmorningevening" class="browser-default" defaultValue="" ref={snacksmidmorningeveningRef} >
                                                            <option value="" disabled >Choose your option</option>
                                                            <option value="Y">Yes</option>
                                                            <option value="N">No</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                    <label>Does {entity.firstname} take at least one of these items with meals daily? 
                                                            Pulses/Dal/Non-vegeterian food(fish, chicken, mutton and eggs)
                                                    </label>
                                                        <select id="mealingredient" class="browser-default" defaultValue="" ref={mealingredientRef} >
                                                            <option value="" disabled >Choose your option</option>
                                                            <option value="Y">Yes</option>
                                                            <option value="N">No</option>
                                                        </select>
                                                    </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                    <label>Does {entity.firstname} have 3 cups of milk or 2 cups of curd daily?
                                                            ( Consider all ways of milk intake including Coffee/Tea/Bournvita/Horlicks etc.) </label>
                                                        <select id="threecupsmilk" class="browser-default" defaultValue="" ref={threecupsmilkRef} >
                                                            <option value="" disabled >Choose your option</option>
                                                            <option value="Y">Yes</option>
                                                            <option value="N">No</option>
                                                        </select>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} take green leafy vegetables (like Spinach, Methi, etc.) daily?</label>
                                                            <select id="greenvegetables" class="browser-default" defaultValue="" ref={greenvegetablesRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="Y">Yes</option>
                                                                <option value="N">No</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} take other vegetables (Like potatoes, tomatoes, carrots, cucumbers, etc.) with their meals daily?</label>
                                                            <select id="othervegetablesintake" class="browser-default" defaultValue="" ref={othervegetablesintakeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="Y">Yes</option>
                                                                <option value="N">No</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} eat fruit daily?</label>
                                                            <select id="fruitintake" class="browser-default" defaultValue="" ref={fruitintakeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="Y">Yes</option>
                                                                <option value="N">No</option>
                                                            </select>
                                                        </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} skip meals?</label>
                                                            <select id="skipmeals" class="browser-default" defaultValue="" ref={skipmealsRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="N">Never</option>
                                                                <option value="R">Rarely</option>
                                                                <option value="O">Often</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} eat junk food? (like pizza, burger, pasta)</label>
                                                            <select id="junkfoodintake" class="browser-default" defaultValue="" ref={junkfoodintakeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="N">Never</option>
                                                                <option value="R">Rarely</option>
                                                                <option value="O">Often</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label>Does {entity.firstname} eat street food? (like chaat, samosa, vadapav, etc.)</label>
                                                            <select id="streetfoodintake" class="browser-default" defaultValue="" ref={streetfoodintakeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="N">Never</option>
                                                                <option value="R">Rarely</option>
                                                                <option value="O">Often</option>
                                                            </select>
                                                        </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label>How many days does {entity.firstname} participate in strenuous
                                                                physical Activity (like playing a sport, running, etc.) for at least 20 minutes?</label>
                                                            <select id="physicalexercise" class="browser-default" defaultValue="" ref={physicalexerciseRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">Less than 4 days a week</option>
                                                                <option value="2">More than 4 days a week</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label>How many hours does {entity.firstname} typically spend on a weekend on television, video games and computer (not including homework)?</label>
                                                            <select id="digitalscreentime" class="browser-default" defaultValue="" ref={digitalscreentimeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">Less than 2 hours</option>
                                                                <option value="2">More than 2 hours</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label>How many hours of sleep does {entity.firstname} get every night?</label>
                                                            <select id="sleeptimes" class="browser-default" defaultValue="" ref={sleeptimesRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">Less than 7 hours</option>
                                                                <option value="2">Between 7 to 9 hours</option>
                                                                <option value="3">More than 9 hours</option>
                                                            </select>
                                                        </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={styles.td33}>
                                                    <div className='imput-field'>
                                                        <label>How many times does {entity.firstname} have high sugar food in a week?
                                                                (cakes, jam, candy, chocolate, ice cream, biscuits, etc.)
                                                        </label>
                                                            <select id="highsugarfoodintake" class="browser-default" defaultValue="" ref={highsugarfoodintakeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">2 times or less</option>
                                                                <option value="2">3 to 5 times</option>
                                                                <option value="3">5 to 10 times</option>
                                                                <option value="4">More than 10 times</option>
                                                                <option value="5">Not every week but up to 2 to 3 times a month</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td34}>
                                                    <div className='imput-field'>
                                                        <label>How many times does {entity.firstname} have high sugar drinks in a week?
                                                            (soft drinks, fruit juice, lassi, flavored milk, etc.) 
                                                        </label>
                                                            <select id="highsugardrinkintake" class="browser-default" defaultValue="" ref={highsugardrinkintakeRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">2 times or less</option>
                                                                <option value="2">3 to 5 times</option>
                                                                <option value="3">5 to 10 times</option>
                                                                <option value="4">More than 10 times</option>
                                                                <option value="5">Not every week but up to 2 to 3 times a month</option>
                                                            </select>
                                                        </div>
                                                </td>
                                                <td style={styles.td33}>                                        
                                                    <div className='imput-field'>
                                                        <label>How many times does {entity.firstname} have refined flour or high fat snacks in a week?
                                                                (chips, nachos, processed cheese, etc.) 
                                                        </label>
                                                            <select id="refinedfoods" class="browser-default" defaultValue="" ref={refinedfoodsRef} >
                                                                <option value="" disabled >Choose your option</option>
                                                                <option value="1">2 times or less</option>
                                                                <option value="2">3 to 5 times</option>
                                                                <option value="3">5 to 10 times</option>
                                                                <option value="4">More than 10 times</option>
                                                                <option value="5">Not every week but up to 2 to 3 times a month</option>
                                                            </select>
                                                        </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </Table>                            
                                    </div>
                            </CardBody>
                            <Card.Footer className="text-right">
                            </Card.Footer>
                        </Card>
                        </div>

                        </Card.Body>
                    </Card>

                    <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                Physical Growth & Health Questionaire
                            </Card.Title>
                        </Card.Header>                    
                        <CardBody>
                            <div>    
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                    </Card>

                    <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                Development Minestone Questionaire
                            </Card.Title>
                        </Card.Header>                    
                        <CardBody>
                            <div>    
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                    </Card>

                    <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                Social Questionaire
                            </Card.Title>
                        </Card.Header>                    
                        <CardBody>
                            <div>    
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                    </Card>

                    <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                Oral Risk Questionaire
                            </Card.Title>
                        </Card.Header>                    
                        <CardBody>
                            <div>    
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                    </Card>

                    <Card className="text-left">
                        <Card.Header className='text-center'> 
                            <Card.Title>
                                Vaccination Questionaire
                            </Card.Title>
                        </Card.Header>                    
                        <CardBody>
                            <div>    
                            </div>

                        </CardBody>
                        <Card.Footer className="text-right">
                        </Card.Footer>
                    </Card>

                </form>

            </div>





        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    const ownentities = state.firestore.ordered.entities ? state.firestore.ordered.entities : state.entity.entities;
    return {
      entities: ownentities,
      auth: state.firebase.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        createWellnessEntity: (entity) => dispatch(createWellnessEntity(entity))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WellnessWizard)

